import {Component, Vue} from 'vue-property-decorator'
import {getAccountsReceivableStatisticalReport} from "@/api/financial-center";
import {delNullProperty} from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {formatDate} from "@/utils/timeFilter";
import {getDeparmentList} from "@/api/common";


@Component({
    components: {
        MoreUsersFilter
    }
})
export default class ARSummaryReport extends Vue {
    loading = false
    tableData: any = []
    filterData = {
        directorUserIdList: [],
        souCourseSchoolBegin: '',
        createdAt: '',
    }
    total = 0
    timer = null
    timeBeginDate: Date[] | null = null
    timeCreateDate: Date[] | null = null
    page = 1   // 当前页码
    pageSize = 20     // 每页条数
    hasNextPage = true  // 是否有下一页
    deparmentList: any = [] // 部门列表
    checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
    departmentIdList = []
    checkDeparmentInfo: any = [] // 选中的部门信息
    accessibleList: any = []

    created() {
        this.getTableData()
    }

    async mounted() {
        await this.getDeparment();
    }

    async getTableData() {
        this.loading = true
        const obj = {
            departmentIdList: this.departmentIdList,
            directorUserIdList: this.filterData.directorUserIdList,
            souCourseSchoolBegin: this.changeTime(this.timeBeginDate as Date[]),
            createdAt: this.changeTime(this.timeCreateDate as Date[]),
            limit: this.pageSize,
            page: this.page
        }
        await getAccountsReceivableStatisticalReport(delNullProperty(obj)).then((data: any) => {
            this.tableData = data.financeOrderList
            this.total = data.allNum
            // // 关键：判断是否有下一页
            // // 如果返回的数据长度 < 每页条数，说明已到最后一页
            // this.hasNextPage = data.financeOrderList.length === this.pageSize;
            setTimeout(() => {
                this.loading = false
            }, 2000);
            this.loading = false
        }).catch(() => {
            this.tableData = []
            // this.hasNextPage = false;
            this.loading = false
        })

    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.pageSize = limit
        this.getTableData()
    }

    changeDirectorUserIdList(e) {
        this.filterData.directorUserIdList = e.id
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = 1
            this.getTableData()
        }, 1000)
    }

    // // 每页条数改变时
    // handleSizeChange(val) {
    //     this.pageSize = val;
    //     this.currentPage = 1; // 重置为第一页
    //     this.getTableData();
    // }
    //
    // // 手动跳转页码时（比如输入页码回车）
    // handleCurrentChange(val) {
    //     // 防止跳转到不存在的页码（比如已到最后一页还手动输入更大的页码）
    //     if (val > this.currentPage && !this.hasNextPage) {
    //         this.currentPage = this.currentPage; // 保持当前页
    //         return;
    //     }
    //     this.currentPage = val;
    //     this.getTableData();
    // }
    //
    // // 点击上一页
    // handlePrevClick() {
    //     if (this.currentPage > 1) {
    //         this.currentPage--;
    //         this.getTableData();
    //     }
    // }
    //
    // // 点击下一页（核心：只有 hasNextPage 为 true 时才执行）
    // handleNextClick() {
    //     if (this.hasNextPage) {
    //         this.currentPage++;
    //         this.getTableData();
    //     }
    // }


    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }

    async getDeparment() {
        const data: any = await getDeparmentList()
        this.deparmentList = data
    }

    chooseDepartment(checkedKeys, checkedData) {

        // 取消勾选
        const [accessibleList, getCheckedKeys] = [this.accessibleList, (this.$refs.tree as HTMLFormElement).getCheckedKeys()];
        // 循环删除this.accessibleList中的项
        for (const i in accessibleList) {
            if (accessibleList[i].id == checkedKeys.id) {
                this.accessibleList.splice(i, 1);
                return;
            }
        }
        // 添加勾选
        const [arr, newArr] = [[], (this.$refs.tree as HTMLFormElement).getCheckedKeys()];
        arr.push(checkedKeys);

        function dealData(arr, newArr) {
            for (const i in arr) {
                newArr.push(arr[i].id);
                dealData(arr[i].children, newArr);
            }
        }

        // newArr代表获取出来的当前节点以及其下的所有子节点的id
        dealData(arr, newArr);
        (this.$refs.tree as HTMLFormElement).setCheckedKeys(newArr);
        // newJsonArr代表所有选中的节点
        const newJsonArr = (this.$refs.tree as HTMLFormElement).getCheckedNodes();
        this.accessibleList = newJsonArr;
        this.checkDeparmentInfo = []

        newJsonArr.map(item => {
            this.checkDeparmentInfo.push({
                department: {
                    name: item.name,
                    detail: null,
                    id: item.id
                },
                departmentId: item.id
            })
        })

    }

    treeChange(item: any, itembol: boolean) {
        if (itembol) {
            const res = (this.$refs.tree as HTMLFormElement).getCheckedNodes()
            const arrDeptId = []
            res.forEach((item) => {
                arrDeptId.push({
                    department: {
                        name: item.name,
                        detail: null,
                        id: item.id
                    },
                    departmentId: item.id
                })
            })
            this.checkDeparmentInfo = arrDeptId
        } else {

            this.checkDeparmentInfo.map((t: any, i: number) => {
                if (t.departmentId === item.id) {
                    this.checkDeparmentInfo.splice(i, 1)
                }
            });
        }

        this.checkRangeDepartmentList = []
        this.checkDeparmentInfo.forEach((item) => {
            this.checkRangeDepartmentList.push(item.departmentId)
        })
        this.departmentIdList = this.checkRangeDepartmentList

    }


    clickDirectorUserName(row: any) {
        // 构建查询参数
        const query: any = {}
        query.directorUserId = row.directorUserId
        query.directorUserName = row.directorUserRealName
        // 检查是否有开课时间或创建时间的搜索条件
        if (this.timeBeginDate) {
            // 如果有开课时间，传递开课时间参数
            query.timeBeginDate = this.changeTime(this.timeBeginDate)
        }
        if (this.timeCreateDate) {
            // 如果有创建时间，传递创建时间参数
            query.timeCreateDate = this.changeTime(this.timeCreateDate)
        }

        // 将查询参数转换为 URL 字符串
        const queryString = Object.keys(query)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
            .join('&')

        // 构建完整的 URL
        const url = window.location.origin +
            this.$route.matched[0].path +
            '/ARChannelDetailReport' +
            (queryString ? `?${queryString}` : '')

        // 打开新窗口
        const win = window.open(url)

        // 监听窗口关闭
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

}
